module.exports = __webpack_public_path__ + "img/fold.2162ee24.svg";